"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEzbuyLang = exports.getLitbLangFn = void 0;
var isomorphismConstant_1 = require("utils/isomorphismConstant");
function getLitbLangFn() {
    var langSource = require("./litb.json");
    return function (key) {
        var keyValues = langSource[key];
        if (!keyValues) {
            return key;
        }
        var lang = isomorphismConstant_1.default.language.toLowerCase() || "en";
        return keyValues[lang] || keyValues["en"];
    };
}
exports.getLitbLangFn = getLitbLangFn;
exports.getEzbuyLang = function () {
    var langSource = require("./ezbuy.json");
    return function (key) {
        var keyValues = langSource[key];
        if (!keyValues) {
            return key;
        }
        var lang = isomorphismConstant_1.default.language.toLowerCase() || "en";
        return keyValues[lang] || keyValues["en"];
    };
};
